// -------------------------------------------------------------------- constants --------------------------------------------------------------------

const INDEX_APP_SETTINGS_SUCCESS = "INDEX_APP_SETTINGS_SUCCESS";
const UPDATE_APP_SETTINGS_SUCCESS = "UPDATE_APP_SETTINGS_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

/**
 *
 * @param {{data: Array}} payload
 * @return {{type: String, payload: Array}}
 * @private
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_APP_SETTINGS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Array}} payload
 * @return {{type: String, payload: Array}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_APP_SETTINGS_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

/**
 * Load settings from server
 * 
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function loadSettings(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/ComputationalSettings/GetComputationalSetting", { params })
      .then((res) => {
        dispatch(_indexSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.basic",
          ".خطا در دریافت تنظیمات! لطفا مجدد تلاش کنید",
          app.translate("routes.home.basic.Loading Settings Failed")
        );
        callback(err);
      });
  };
}

/**
 * Save settings to server
 * 
 * @param {Array} data - Settings to save
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function saveSettings(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("در حال بروزرسانی")
    );

    api
      .put("/ComputationalSettings/UpdateComputationalSetting", { data })
      .then((res) => {
        dispatch(_updateSuccess(res));
        loader.hide(() =>
          app.message(
            app.translate("بروزرسانی باموفقیت انجام شد")
          )
        );
        callback(undefined, res);
      })
      .catch((err) => {
        loader.hide(() =>
          app.error(
            err,
            "routes.home.basic",
            "خطا در ذخیره تنظیمات",
            app.translate("خطا در ذخیره تنظیمات")
          )
        );
        callback(err);
      });
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    settings: [],
  },
  action
) {
  switch (action.type) {
    case INDEX_APP_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        settings: action.payload.data,
      });
    case UPDATE_APP_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        settings: action.payload,
      });
    default:
      return state;
  }
}